"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAddressForm = void 0;
const react_1 = __importStar(require("react"));
const types_1 = require("./types");
const useAddressValidations_1 = require("./hooks/useAddressValidations");
const useAddressServices_1 = require("./hooks/useAddressServices");
const useOptions_1 = require("./hooks/useOptions");
const useMetadata_1 = require("./hooks/useMetadata");
function useAddressForm(props, config) {
    const { defaultValues, onChange, onChangeMetadata, showErrors } = props;
    const { services, translations, variant = 'DEFAULT' } = config;
    const [values, setValues] = react_1.default.useState(defaultValues);
    const { metaState, onLoading, updateDirtyFields, updateErrors, updateTouchedFields } = (0, useMetadata_1.useMetadata)({ onChangeMetadata });
    const { cities, provinces } = (0, useAddressServices_1.useAddressServices)({
        provinceSelected: values.province,
        services,
        onLoading,
    });
    const { validateField, validateAll } = (0, useAddressValidations_1.useAddressValidations)({ translations, provinces });
    const { provinceOptions, cityOptions, roadTypeOptions, addressSuggestionsOptions } = (0, useOptions_1.useOptions)({
        provinces,
        cities,
    });
    (0, react_1.useEffect)(() => {
        updateErrors(validateAll(values));
    }, []);
    const handleChange = (0, react_1.useCallback)((event) => {
        const { name, value } = event.target;
        const fieldName = name;
        setValues(prevValues => {
            const newValues = { ...prevValues, [fieldName]: value };
            if (fieldName === types_1.AddressFieldNames.PROVINCE && value !== prevValues[types_1.AddressFieldNames.PROVINCE]) {
                newValues[types_1.AddressFieldNames.CITY] = '';
                updateDirtyFields(types_1.AddressFieldNames.CITY, defaultValues[types_1.AddressFieldNames.CITY] !== '');
            }
            updateDirtyFields(fieldName, defaultValues[fieldName] !== value);
            onChange(newValues, event);
            return newValues;
        });
    }, [onChange, defaultValues, updateDirtyFields]);
    const handleBlur = (event) => {
        const { name, value } = event.target;
        const fieldName = name;
        updateErrors(validateField({
            fieldName,
            value,
            values,
            prevErrors: metaState.errorFields,
        }));
        updateTouchedFields(fieldName, true);
    };
    return {
        onChange: handleChange,
        onBlur: handleBlur,
        touchedFields: metaState.touchedFields,
        dirtyFields: metaState.dirtyFields,
        isValid: metaState.meta.isValid,
        errors: metaState.errorFields,
        validateAll,
        validateField,
        values,
        addressSuggestionsOptions,
        cityOptions,
        roadTypeOptions,
        provinceOptions,
        translations,
        variant,
        showErrors,
    };
}
exports.useAddressForm = useAddressForm;
//# sourceMappingURL=useAddressForm.js.map